module.exports = __webpack_public_path__ + "static/media/7.37fa9312.png";